import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AcercaPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-4xl mx-auto px-4 py-8 sm:py-12">
        <button onClick={() => navigate(-1)} className="text-sm text-zl-orange mb-4 hover:underline">&larr; Volver</button>
        <h1 className="text-2xl sm:text-3xl font-bold mb-6">Acerca de Zona Libre</h1>
        <div className="bg-white rounded-lg p-6 sm:p-8 space-y-6 text-sm text-gray-700 leading-relaxed">
          <section>
          <h2 className="text-lg font-bold text-gray-900 mb-2">Nuestra Historia</h2>
          <p>Zona Libre nace como una iniciativa de <strong>TrendyShop de Mexico S. de R.L. de C.V.</strong> para democratizar el comercio electronico en Mexico. Nuestra mision es conectar a compradores y vendedores de todo el pais en una plataforma segura, accesible y justa.</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Nuestra Mision</h2>
          <p>Empoderar a emprendedores, pequenos y medianos comerciantes mexicanos brindandoles las herramientas tecnologicas necesarias para competir en el mercado digital, mientras ofrecemos a los compradores la mejor experiencia de compra en linea.</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Empresa Responsable</h2>
          <p><strong>TrendyShop de Mexico S. de R.L. de C.V.</strong> es la razon social propietaria de la marca comercial "Zona Libre". Estamos constituidos bajo las leyes de Mexico y operamos bajo los mas altos estandares de transparencia, seguridad y cumplimiento regulatorio.</p></section>

          <section><h2 className="text-lg font-bold text-gray-900 mb-2">Cifras Clave</h2>
          <div className="grid grid-cols-3 gap-4 text-center">
            <div className="bg-zl-orange-50 rounded-lg p-4"><p className="text-2xl font-bold text-zl-orange">1000+</p><p className="text-xs text-gray-500">Vendedores activos</p></div>
            <div className="bg-zl-orange-50 rounded-lg p-4"><p className="text-2xl font-bold text-zl-orange">50K+</p><p className="text-xs text-gray-500">Productos publicados</p></div>
            <div className="bg-zl-orange-50 rounded-lg p-4"><p className="text-2xl font-bold text-zl-orange">32</p><p className="text-xs text-gray-500">Estados de Mexico</p></div>
          </div></section>

          <p className="text-xs text-gray-400 border-t pt-4">TrendyShop de Mexico S. de R.L. de C.V. — Ciudad de Mexico, Mexico</p>
        </div>
      </div>
    </div>
  );
}
